// Table
import Table from '@/components/ui/table/Table'

// Dayjs
import dayjs from 'dayjs'

// Mantine
import { Anchor } from '@mantine/core'

// Lib
import { getVerboseShipment, statuses } from '@/lib/shipment'

// Classnames
import classNames from 'classnames'

// Cells
const CodeCell = (item) => (
    <div className="table-cell p-5 text-gray-500">
        <div className="flex flex-col">
            <Anchor>{item.tracking_code}</Anchor>
            <span className="text-sm">{dayjs(item.created_at).calendar()}</span>
        </div>
    </div>
)

const FromToCell = ({ item, label, location, address }) => (
    <div className="table-cell p-5 text-gray-500">
        <div className="flex flex-col">
            {location && <span className="text-gray-500">{location.name}</span>}
            {!location && <span className="text-gray-500">Client</span>}

            <span className="text-sm text-gray-400">
                {[address.city, address.country].filter(Boolean).join(' - ')}
            </span>
        </div>
    </div>
)

const FromCell = (item) => (
    <FromToCell
        item={item}
        location={item.from_location}
        address={item.from_address}
        label="Expéditeur"
    />
)

const ToCell = (item) => (
    <FromToCell
        item={item}
        location={item.to_location}
        address={item.to_address}
        label="Destinataire"
    />
)

const TrackingCell = (item) => {
    const verboseShipment = getVerboseShipment(item)
    const verboseStatus = verboseShipment.verbose_tracking_status

    return (
        <div className="table-cell p-5 text-gray-500 text-sm">
            <div className="flex flex-col">
                <span className={classNames(verboseStatus.textColor)}>
                    {verboseStatus.label}
                </span>

                <span className="truncate max-w-[200px]">
                    {item.last_tracker_message}
                </span>

                {item.scanned_at && <span>Colis expédié</span>}
            </div>
        </div>
    )
}

const ServiceCell = (item) => {
    const verboseShipment = getVerboseShipment(item)

    return (
        <div className="table-cell p-5 text-gray-400 text-sm">
            <div className="flex flex-col">
                <span>{verboseShipment.verbose_service?.code || 'N/A'}</span>

                <span>{item.incoterm}</span>
            </div>
        </div>
    )
}

export default function ShipmentsTable() {
    const availableColumns = [
        {
            name: 'Code',
            key: 'code',
            display: 'mandatory',
            sortable: true,
            component: CodeCell,
        },
        {
            name: 'Expéditeur',
            key: 'from_location',
            display: 'optional_default',
            sortable: true,
            component: FromCell,
        },
        {
            name: 'Destinataire',
            key: 'to_location',
            display: 'optional_default',
            sortable: true,
            component: ToCell,
        },
        {
            name: 'Tracking',
            key: 'tracking',
            display: 'optional_default',
            sortable: true,
            component: TrackingCell,
        },
        {
            name: 'Service',
            key: 'service',
            display: 'optional_default',
            sortable: true,
            component: ServiceCell,
        },
    ]

    const statusOptions = [
        ...Object.keys(statuses).map((status) => ({
            label: statuses[status].label,
            value: status,
        })),
        {
            label: 'Sans statut',
            value: 'ee',
        },
    ]

    const availableFilters = [
        {
            name: 'Statut',
            key: 'tracking_status',
            type: 'multiselect',
            options: statusOptions,
        },
    ]

    return (
        <Table
            searchable={true}
            availableColumns={availableColumns}
            availableFilters={availableFilters}
            engineApiEndpoint="/shipments"
            defaultSortColumn="created_at"
            defaultSortDirection="desc"
            linkItemId="id"
            linkItemUrl="/shipments"
        />
    )
}
